<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">正規登録</li>
            </ol>
        </nav>
        <div class="container p-0">
            <h3>
                正規登録
            </h3>
            <div class="text-muted mb-3">
                ゲストアカウントはログアウトすると削除されます。<br>
                正規登録することで、アカウントが保存され、貸し本棚の全機能を利用できます。
            </div>
            <div class="row">
                <div class="col-md-6">
                    <h4 class="mt-3">Googleアカウントで登録</h4>
                    <div class="forms">
                        <div class="my-3">
                            <a href="/login/google" class="btn btn-google btn-block">
                                <i class="fab fa-google"></i>
                                Googleアカウントで登録
                            </a>
                        </div>
                        <div>
                            Googleのアカウントをお持ちの方は、
                            ワンクリックで登録が完了します。
                            パスワードは必要ありません。
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <h4 class="mt-3">メールアドレスで登録</h4>
                    <div class="forms">
                        <div class="mb-3">
                            <label>
                                ユーザ名
                                <span class="badge badge-danger">必須</span>
                            </label>
                            <input type="text" class="form-control form-control-lg" v-model="user.name" />
                        </div>
                        <label>
                            メールアドレス
                            <span class="badge badge-danger">必須</span>
                        </label>
                        <input type="email" class="form-control" v-model="user.email" placeholder="有効なメールアドレスを入力してください" autocomplete="new-email" id="email" />
                        <div class="mt-3">
                            <label>
                                パスワード
                                <span class="badge badge-danger">必須</span>
                            </label>
                            <input type="password" class="form-control" v-model="user.password" placeholder="8文字以上" autocomplete="new-password" id="password" />
                            <div class="text-muted small">8文字以上のパスワードを設定してください。</div>
                        </div>
                        <div class="mt-3">
                            <button type="button" class="btn btn-primary" @click="register()">
                                メールアドレスで登録
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped>
.forms {
    border: 1px solid #bbb;
    border-radius: .5rem;
    padding: 1rem;
    margin-top: 1rem;
}
@media screen and (max-width: 770px) {
    .forms {
        margin-top: .5rem;
    }
}
</style>

<script>
export default {
    data() {
        return {
            user: {
                name: this.$store.state.user ? this.$store.state.user.name : "",
                email: "",
                password: "",
            },
            isLoading: false,
        }
    },
    methods: {
        register() {
            this.isLoading = true;
            axios.post("/mypage/user/register", this.user).then(res => {
                alert.msg(res.data);
                setTimeout(() => {
                    location.href = "/mypage";
                    this.isLoading = false;
                }, 1000);
            }).catch(err => {
                alert.err(err);
                this.isLoading = false;
            });
        }
    },
}
</script>